require('./sctTabs.scss');

const sctTabs = angular.module('app.sct.sctTabs', []);

sctTabs.component('sctTabs', {
  bindings: {
    settings: '<'
  },
  controller: [sctTabsCtrl],
  controllerAs: 'vm',
  template: require('./sctTabs.html')
});

function sctTabsCtrl() {
  let vm = this;

  vm.navHighlighterConfig = {
    itemsName: 'a',
    itemActiveClassName: 'active',
    indicatorClassName: 'sctTabs_tabs_indicator'
  };

}

export default sctTabs;



// WEBPACK FOOTER //
// ./src/components/sct/sctTabs/sctTabs.js